module.exports = __webpack_public_path__ + "static/media/header-mail.a7231f84.svg";